<div class="container-gallery">
<div class="only-desktop">
  <p-galleria
    [value]="getPictures()"
    [showThumbnails]="true"
    [showThumbnailNavigators]="true"
    [showItemNavigators]="true"
    [circular]="true"
    [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '800px' }"
    [numVisible]="5"
    [activeIndex]="activeIndex"
    [thumbnailsPosition]="'left'"
    >
    <ng-template pTemplate="item" let-item let-i="index" >
      <div class="container"
        style="
        display:flex;
        justify-content: center;
        align-items: center;
        height:485px;
        padding:0 1em;

        "
      >
        <img loading="lazy" [src]="completeUrl(item.url)"
        (click)="imageClick(item.id)"
        style="
          object-fit: cover;
          width: 100%;
          height: 100%;
          cursor: pointer;
          border-radius:10px;
          overflow:hidden;
        " />
      </div>

    </ng-template>
    <ng-template pTemplate="thumbnail" let-item let-i="index">
      <div
        class="justify-content-center"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 100px;
          padding:.5em 0;
        "
        >
        <img loading="lazy" [src]="completeUrl(item.url)"
        (click)="imageClick(item.id)"
          style="
            object-fit: cover;
            width: 100%;
            height: 100%;
            width: 100%;
            border-radius: 4px;
            overflow: hidden;
            border-radius:10px;
          "

        />
      </div>
    </ng-template>
  </p-galleria>
</div>
<div class="only-mobile">
  <p-galleria
    [value]="getPictures()"
    [showThumbnails]="false"
    [showThumbnailNavigators]="true"
    [showItemNavigators]="true"
    [circular]="true"
    [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '800px' }"
    [numVisible]="5"
    [activeIndex]="activeIndex"
    [thumbnailsPosition]="'bottom'"
    >
    <ng-template pTemplate="item" let-item let-i="index" >
      <div class="container"
        style="
        display:flex;
        justify-content: center;
        align-items: center;
        height:485px;
        padding:0 1em;

        "
      >
        <img loading="lazy" [src]="completeUrl(item.url)"
        (click)="imageClick(item.id)"
        style="
          object-fit: cover;
          width: 100%;
          height: 100%;
          cursor: pointer;
          border-radius:10px;
          overflow:hidden;
        " />
      </div>

    </ng-template>
    <ng-template pTemplate="thumbnail" let-item let-i="index">
      <div
        class="justify-content-center"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 100px;
          padding:.5em 0;
        "
        >
        <img loading="lazy" [src]="completeUrl(item.url)"
        (click)="imageClick(item.id)"
          style="
            object-fit: cover;
            width: 100%;
            height: 100%;
            width: 100%;
            border-radius: 4px;
            overflow: hidden;
            border-radius:10px;
          "

        />
      </div>
    </ng-template>
  </p-galleria>
</div>



  <!--
  <p-galleria
    [value]="getPictures()"
    class="galleria-full"
    [(visible)]="displayBasic"
    [responsiveOptions]="responsiveOptions"
    [numVisible]="1"
    [(activeIndex)]="activeIndex"
    [circular]="true"
    [fullScreen]="true"
    [showItemNavigators]="true"
    [showThumbnails]="true"
    [thumbnailsPosition]="'bottom'"
    >
    <ng-template pTemplate="item" let-item>
      <div class="image-container">
        <img [src]="completeUrl(item.url)" style="width: 100%; display: block;" class="gallery-image" />
      </div>
    </ng-template>
  </p-galleria>
    -->


  </div>
